<template>
  <div class="reportpage">
    <div class="reporterror" v-if="loading">loading...</div>
    <div class="reporterror" v-else-if="error">{{error}}</div>
    <main class="reportbox" v-else>
      <header class="report-header">
        <p class="eyebrow">COURSE REPORT</p>
        <h1>课程学习反馈</h1>
        <p>{{resultData.course_time}}</p>
      </header>
      <section class="report-card basic-grid">
        <div><span>学员</span><strong>{{resultData.student_name || '-'}}</strong></div>
        <div><span>上课老师</span><strong>{{resultData.teacher_name || '-'}}</strong></div>
      </section>
      <section class="report-card">
        <h2>分级定位</h2>
        <div class="level-path">
          <div><span>当前等级</span><strong>{{level.current || '-'}}</strong></div>
          <i>→</i>
          <div><span>目标等级</span><strong>{{level.target || '-'}}</strong></div>
        </div>
      </section>
      <section class="report-card">
        <h2>当前教学内容</h2>
        <p class="pending" v-if="resultData.progress_pending">老师正在补充本次课程进度</p>
        <div class="material-progress" v-else>
          <span class="category" v-if="progress.category_path">{{progress.category_path}}</span>
          <strong>{{progress.document_name || '-'}}</strong>
          <p>Unit {{progress.unit}} · Page {{progress.end_page}}</p>
        </div>
      </section>
      <section class="report-card">
        <h2>五维评分</h2>
        <p class="pending" v-if="resultData.grade_pending">老师正在补充本次课程反馈</p>
        <score-bars v-else :rows="scores"></score-bars>
      </section>
      <section class="report-card next-step">
        <h2>🎯 下一步</h2>
        <strong>{{level.target || '-'}}</strong>
        <p>{{level.goal || '-'}}</p>
      </section>
    </main>
  </div>
</template>

<script>
import { common } from '../../../common.js'
import ScoreBars from './scoreBars.vue'
const { scoreRows } = require('./reportViewModel')

export default {
  components: { ScoreBars },
  data: function () { return { loading: true, error: '', resultData: {} } },
  computed: {
    level: function () { return this.resultData.level || {} },
    progress: function () { return this.resultData.progress || {} },
    scores: function () { return scoreRows(this.resultData.grade) }
  },
  mounted: function () {
    document.getElementById('app').className += ' appmobile'
    const id = this.$route.query.id
    common.requestFun(this, 'get', '/student/course/grade/' + id, {}, (res) => {
      this.loading = false
      if (res.data.code === 200) this.resultData = res.data.data || {}
      else this.error = res.data.msg || '课程反馈加载失败'
    })
  }
}
import '../../assets/css/common.css'
</script>

<style scoped src="./index.css"></style>
